var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 74.911,
    cy: 76.481,
    r: 26.329
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.8;0",
    begin: 0.4,
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 74.911,
    cy: 76.481,
    r: 15.19
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.9;0",
    begin: 0.2,
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 74.911,
    cy: 76.481,
    r: 5.063
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    begin: 0,
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 74.911,
    cy: 76.481,
    r: 37.975
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.5;0",
    begin: 0.6,
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress1);
export default __webpack_public_path__ + "static/media/progress1.c6762947c9588c938ee2f282429b6345.svg";
export { ForwardRef as ReactComponent };